import React, { useState } from 'react';
import 'aos/dist/aos.css';
import smakonecup from '../Assets/SmakonecupLogo.webp';
import '../index.css'
import { Link } from 'react-router-dom';

function Navbar() {
  const [menuVisible, setMenuVisible] = useState(false);

  function toggleMenu() {
    setMenuVisible(!menuVisible);
  }

  return (
    <div className='m-0 px-[10px] text-[35px] fixed w-full backdrop-blur-lg bg-gray-300/30 z-50'>
      <div className="grid grid-cols-3 font-[JakartaSans]">
        <div className='font-[600] text-left w-[500px]'>
            <Link to="/"><img src={smakonecup} alt="" className='h-[70px] py-[5px] lg:py-0 lg:h-[100px] justify-start'/></Link>
        </div>
        <div className='w-[30px] shadow-none'></div>
        <div className='justify-end text-right flex font-[JakartaSans] text-white my-auto'>
          <ul className='gap-8 text-[25px] hidden lg:flex'>
            <li className='menu-item hover:text-purple-400'><Link to='/about'>About</Link></li>
            <li className='menu-item hover:text-purple-400'><Link to='/competition'>Competition</Link></li>
            <li className='menu-item hover:text-purple-400'><Link to='/scoreboard'>Scoreboard</Link></li>
            <li className='menu-item hover:text-purple-400'><a title='Please use DESKTOP' href='https://socregis.smakone.org'>Registration</a></li>
          </ul>
          <button onClick={toggleMenu} className='flex lg:hidden'>
            <svg width="30px" height="30px" viewBox="0 0 24 24" fill={"white"} stroke="white" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4ZM7 12C7 11.4477 7.44772 11 8 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H8C7.44772 13 7 12.5523 7 12ZM13 18C13 17.4477 13.4477 17 14 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H14C13.4477 19 13 18.5523 13 18Z" fill="#000000"/>
            </svg>
          </button>
        </div>
      </div>

      {menuVisible && (
        <div className="block lg:hidden pb-4 top-full -mt-[10px] right-0 text-[20px]"
            // data-aos="fade-in"
            // data-aos-offset="100"
            // data-aos-duration="1000"
            // data-aos-delay="0"
            // alt=""
        >
          <ul className='w-full'>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer text-center' onClick={toggleMenu}><Link to='/about'>About</Link></li>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer text-center' onClick={toggleMenu}><Link to='/competition'>Competition</Link></li>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer text-center' onClick={toggleMenu}><a title='please use desktop' href='https://socregis.smakone.org'>Registration</a></li>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer text-center' onClick={toggleMenu}><Link to='/scoreboard'>Scoreboard</Link></li>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer text-center' onClick={toggleMenu}><Link to='/soundscape'>Soundscape</Link></li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Navbar;
